var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrayon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.652 2.602c-.922.507-3.015 2.543-3.015 2.953 0 .445 5.777 6.191 6.218 6.191.192 0 1.016-.7 1.844-1.586 1.207-1.305 1.461-1.777 1.461-2.762 0-3.144-4.066-6.128-6.508-4.796zm0 0M12.129 13.746c-4.035 4.031-7.367 7.524-7.367 7.684 0 .41 5.777 6.187 6.191 6.187.192 0 3.746-3.426 7.902-7.586l7.622-7.617-2.985-3.016c-1.652-1.683-3.207-3.05-3.46-3.05-.286 0-3.84 3.336-7.903 7.398zm0 0M2.922 26.031c-.574 2.098-1.016 4-1.016 4.254 0 .414.508.317 7.778-1.683l.953-.254L7.652 25.3C6 23.586 4.477 22.223 4.285 22.223c-.223 0-.824 1.715-1.363 3.808zm0 0"
  }))));
}
export default SvgCrayon;